module.exports = __webpack_public_path__ + "img/icon-usdt.fff068ce.png";